import React from "react";
import CustomLink from "../../CustomLink";
import { PersonalizeIt } from "../../../Constants";
import { useTranslation } from "react-i18next";

const Tabs = ({ data, activeFormula, onClick, isProductPage = false }) => {
  const { t } = useTranslation();
  return (
    <div className="t-w-full md:t-w-fit t-flex t-items-center t-gap-4 t-overflow-scroll hide-scrollbar">
      {Object.keys(data).map((item) => {
        const name = data[item]?.name;
        return (
          <button
            className={`t-flex-none t-w-fit t-h-[40px] t-px-4 t-rounded-md t-font-semibold t-text-sm t-transition-colors ${
              activeFormula === item
                ? "t-bg-quiz-teal t-text-white"
                : "t-border t-border-g200 t-text-navy hover:t-border-quiz-teal"
            }`}
            onClick={() => onClick(item)}
          >
            {name}
          </button>
        );
      })}
      {isProductPage && (
        <CustomLink
          to="/quiz"
          className={`t-flex-none t-w-fit t-h-[40px] t-py-2 t-px-4 t-rounded-md t-font-semibold t-text-sm t-border t-border-butter t-text-navy hover:t-bg-butter t-transition-colors`}
        >
          {t(PersonalizeIt)}
        </CustomLink>
      )}
    </div>
  );
};

export default Tabs;
